export default __webpack_public_path__ + "static/media/pdf-img.e5fbd531.jpg";